import { useMemo } from "react";
import { scoreTown } from "../lib/scoring.js";
import { hardCriteriaCheck, countPass, STATUS_META } from "../lib/hardCriteria.js";

// Genereert één beslis-zin uit de scores + harde eisen.
function buildVerdict(pct, items, town, concelho) {
  const headline =
    pct >= 70 ? "Sterke match voor jullie plan" :
    pct >= 50 ? "Redelijke match — met kanttekeningen" :
                "Zwakke match voor jullie plan";

  const pos = [];
  const sea = town?.hardRequirements?.seaDistanceMin;
  if (sea != null && sea <= 30) pos.push(`${sea} min van zee`);
  const mon = town?.nearest_montessori;
  if (mon?.km != null && mon.km <= 60) pos.push(`Montessori op ${Math.round(mon.km)} km`);
  if ((concelho?.food_autonomy ?? 0) >= 3) pos.push("ruimte voor zelfvoorziening");

  const warn = items.filter(i => i.status === "fail" || i.status === "warn")
    .map(i => i.label.toLowerCase());

  let body = pos.slice(0, 3).join(" · ");
  if (warn.length) body += `${body ? ". " : ""}Let op: ${warn.slice(0, 2).join(" en ")}.`;
  return { headline, body };
}

function ringColorFor(pct) {
  return pct >= 70 ? "#3b7a35" : pct >= 50 ? "#c17f2a" : "#c94040";
}

export function VerdictCard({ town, concelho, weights }) {
  const { pct } = scoreTown(town, weights, concelho);
  const rounded = Math.round(pct);
  const items   = useMemo(() => hardCriteriaCheck(town, concelho), [town, concelho]);
  const { headline, body } = buildVerdict(rounded, items, town, concelho);
  const col = ringColorFor(rounded);
  const r = 26, circ = 2 * Math.PI * r, offset = circ * (1 - rounded / 100);

  return (
    <div className="verdict-card">
      <div className="verdict-ring">
        <svg width="64" height="64" viewBox="0 0 64 64" style={{ transform: "rotate(-90deg)" }}>
          <circle cx="32" cy="32" r={r} fill="none" stroke="#e8e4dc" strokeWidth="5" />
          <circle cx="32" cy="32" r={r} fill="none" stroke={col} strokeWidth="5"
            strokeDasharray={circ.toFixed(1)} strokeDashoffset={offset.toFixed(1)} strokeLinecap="round" />
        </svg>
        <div className="verdict-ring-inner">
          <span style={{ fontSize: 18, fontWeight: 700, color: col, lineHeight: 1 }}>{rounded}</span>
          <span style={{ fontSize: 8, color: "#aaa" }}>/100</span>
        </div>
      </div>
      <div className="verdict-text">
        <p className="verdict-headline" style={{ color: col }}>{headline}</p>
        {body && <p className="verdict-body">{body}</p>}
      </div>
    </div>
  );
}

export function HardCriteria({ town, concelho }) {
  const items = useMemo(() => hardCriteriaCheck(town, concelho), [town, concelho]);
  if (!items.length) return null;
  return (
    <div className="hc-wrap">
      <div className="hc-title">JULLIE HARDE EISEN — {countPass(items)}/{items.length} groen</div>
      <div className="hc-grid">
        {items.map(it => {
          const m = STATUS_META[it.status] || STATUS_META.info;
          return (
            <div key={it.id} className="hc-item">
              <span className="hc-sym" style={{ color: m.color }}>{m.symbol}</span>
              <span className="hc-label">{it.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
